import Wrapper from '@/layout/components/Wrapper/index.vue';
import Home from '@/views/website/home/index.vue';
import Document from '@/views/Document.vue';
import Tab from '@/views/Tab.vue';
import Image from '@/views/Image.vue';
import Button from '@/views/Button.vue';
import Date from '@/views/Date.vue';
import Component from '@/views/Component.vue';
/**
 * 
 * 路由配置规则：
 * 
 * {
 *  path:'',路径
 *  name:'',路由名称，生成menu时menu name
 *  meta:{},额外信息，icon为menu中的icon
 *  children: [], 子路由，menu中的子menu 没有时可为空数组
 * }
 * 
 */
export const staticRoutes = [
  {
    path: '/',
    name: '首页',
    meta: {
      title: '晋才科技',
      icon: 'el-icon-s-home'
    },
    component: () => import('@/weblayout/index.vue'),
    children: [
      {
        path: '/home',
        name: '首页',
        meta: {
          title: '晋才科技 - 首页',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/home/Index.vue')
      },
      {
        path: '/website/product',
        name: '产品中心',
        meta: {
          title: '晋才科技 - 产品中心',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/product/Index.vue')
      },
      {
        path: '/website/product/details',
        name: '产品详情',
        meta: {
          title: '晋才科技 - 产品详情',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/product/Details.vue')
      },
      {
        path: '/website/news',
        name: 'news',
        meta: {
          title: '晋才科技 - 新闻中心',
          icon: 'el-icon-s-home',
          keepAlive: true,
        },
        component: () => import('@/views/website/news/Index.vue')
      },{
        path: '/website/recruitment',
        name: '人才招聘',
        meta: {
          title: '晋才科技 - 人才招聘',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/recruitment/Index.vue')
      },{
        path: '/website/customer',
        name: '客户合作',
        meta: {
          title: '晋才科技 - 客户合作',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/customer/Index.vue')
      },{
        path: '/website/support',
        name: '服务支持',
        meta: {
          title: '晋才科技 - 服务支持',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/support/Index.vue')
      },{
        path: '/website/case',
        name: '工程案例',
        meta: {
          title: '晋才科技 - 工程案例',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/case/Index.vue')
      },{
        path: '/website/solution',
        name: '解决方案',
        meta: {
          title: '晋才科技 - 解决方案',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/solution/Index.vue')
      },{
        path: '/website/aboutUs',
        name: '关于',
        meta: {
          title: '晋才科技 - 关于我们',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/about/Index.vue')
      },{
        path: '/website/news/details',
        name: '新闻详情',
        meta: {
          title: '晋才科技 - 新闻详情',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/website/news/Details.vue')
      }
      
    ],
  },
   
];
